var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-a-tpl-public"},[(!_vm.open)?_c('template-list',{attrs:{"scrollEl":".admin-template-public","projectId":_vm.$store.state.app.loginUser.publicProject.id},on:{"open":function($event){_vm.open = true}}}):_vm._e(),_c('category-manage',{model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }